import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import '../../assets/style/homeServices.scss';

const ServiceList = (props) => {
  let options = [{
    title: "活动教案",
    iconFont: "icon-icon-hd",
    color: 'blue'
  }, {
    title: "一日计划",
    iconFont: "icon-icon-jh",
    color: 'blue'
  }, {
    title: "周计划",
    iconFont: "icon-icon-jh",
    color: 'blue'
  }, {
    title: "主题方案",
    iconFont: "icon-icon-jh-1",
    color: 'blue'
  }, {
    title: "观察评价",
    iconFont: "icon-icon-gc",
    color: 'blue'
  }, {
    title: "游戏活动",
    iconFont: "icon-icon-hd",
    color: 'blue'
  }, {
    title: "主题活动",
    iconFont: "icon-icon-hd-1",
    color: 'blue'
  }, {
    title: "反思总结",
    iconFont: "icon-icon-fs",
    color: 'blue'
  }, {
    title: "家庭教育文案",
    iconFont: "icon-icon-jt",
    color: 'green'
  }, {
    title: "群通知",
    iconFont: "icon-icon-tw",
    color: 'green'
  }, {
    title: "亲子活动",
    iconFont: "icon-icon-qzhd",
    color: 'green'
  }, {
    title: "家园沟通",
    iconFont: "icon-icon-gt",
    color: 'green'
  }, {
    title: "家长会方案",
    iconFont: "icon-icon-fs",
    color: 'green'
  }, {
    title: "家园共育计划",
    iconFont: "icon-icon-jh-1",
    color: 'green'
  }, {
    title: "活动策划",
    iconFont: "icon-icon-hd-1",
    color: 'yellow'
  }, {
    title: "活动通知",
    iconFont: "icon-icon-tw",
    color: 'yellow'
  }, {
    title: "热场游戏",
    iconFont: "icon-icon-hd-1",
    color: 'yellow'
  }, {
    title: "主持稿",
    iconFont: "icon-icon-hd",
    color: 'yellow'
  }, {
    title: "活动总结",
    iconFont: "icon-icon-hd-2",
    color: 'yellow'
  }, {
    title: "活动推文",
    iconFont: "icon-icon-tw",
    color: 'yellow'
  }];
  useImperativeHandle(props.onRef, () => {
    return {
      onServiceListScroll: onServiceListScroll
    }
  })
  const containerRef = useRef(null);
  const itemHeight = 68;
  const visibleCount = Math.floor((window.innerHeight - 100) / itemHeight);
  const middleIndex = Math.floor(visibleCount / 2);
  const [selectedIndex, setSelectedIndex] = useState(19);
  const [currentIndex,setCurrentIndex] = useState()
  const scrollTimeout = useRef(null);

  const onServiceListScroll = (pScrollTop,servicesWrapScrollT) => {
    let containeRefTop = containerRef.current.getBoundingClientRect().top
   // const topDistance = containeRefTop+ window.scrollY
    const scrollTop = pScrollTop-servicesWrapScrollT;
    // console.log('Math.round(scrollTop / itemHeight)-----\n',Math.round(scrollTop / itemHeight),containeRefTop <= 100&&scrollTop <1870)
    if (containeRefTop <= 100&&scrollTop <1870) {
      let index = Math.round(scrollTop / itemHeight);
      // console.log('index',index)
      if(index<=19){
        index = 19 - index
      } else {
        index = 39-index
      }
      // console.log('index',index,visibleCount)
      if( 0 <= index&& index <= 5){
        setCurrentIndex(5 - index)
      } else if( 6 <= index <= 19){
        setCurrentIndex(25 - index)
      }

      // console.log('滚动', pScrollTop,
      // '\n在列表里滚动了',scrollTop,
      // '\n列表距顶',containeRefTop,
      // '\nindex',index,
      // '\n列表距页面',topDistance,
      // '\nsssss',containerRef.current.scrollTop,
      // '\nservicesWrapScrollT',servicesWrapScrollT
      // )

      setSelectedIndex(index);

      // 如果用户停止滚动，自动对齐吸附
      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
      scrollTimeout.current = setTimeout(() => {
        containerRef.current.scrollTo({
          top: index * itemHeight,
          behavior: 'smooth',
        });
      }, 0);
    }

  };

  useEffect(() => {
    props.onChange?.(options[selectedIndex]);
  }, [selectedIndex, props, options]);

  // 初始化时滚动到中间
  useEffect(() => {
    setTimeout(() => {
      containerRef.current.scrollTo({
        top: selectedIndex * itemHeight,
        behavior: 'auto',
      });
    }, 0);
  }, [selectedIndex,itemHeight]);
  return (
    <div
      className="picker-container"

    >
      <div className='discontent'>
        <div
          className={`picker-list picker-list${selectedIndex}`}
          ref={containerRef}
          style={{
            height: `${itemHeight * visibleCount}px`,
          }}
        >
          {options.map((option, index) => (
            <div key={index} className={`picker-item ${index === currentIndex ? 'selected' : ''} picker-item${index}`}>
              <div className={`icon iconfont ${option.iconFont} ${option.color} `}></div>
              {option.title}
            </div>
          ))}
        </div>
        {/* 居中选区遮罩框 */}
        <div
          className="picker-highlight"
          style={{
            top: `${itemHeight * middleIndex}px`,
            height: `${itemHeight}px`,
          }}
        />
      </div>
    </div>

  );
}

export default ServiceList;